import React from "react";
import {  Row } from "antd";
import FAQPanelContainer from "./FAQAdminPanelContainer/FAQAdminPanelContainer";
import AppContainer from "~v2/components/AppContainer/AppContainer";

const FAQPage = () => {
  return (
    <AppContainer title="HELP/FAQ">
      <center>
        <Row
          style={{ margin: "15px 20px" }}
          align="middle"
          justify="center"
          className="faq"
        >
          <FAQPanelContainer />
        </Row>
      </center>
    </AppContainer>
  );
};

export default FAQPage;
